export enum CustomerType {
	None,
	Private = 1,
	Commercial
}